{
  "Binary": "バイナリー",
  "Calculation": "計算",
  "Compensation-Plan": "報酬プラン",
  "Create-Account": "アカウント作成",
  "Dashboard": "ダッシュボード",
  "Document-Import": "ドキュメント取込",
  "Document-Registry": "ドキュメント登録",
  "Entire-Network": "ネットワーク全体",
  "Finance-Payouts": "支払い",
  "Finance-Transactions": "取引",
  "Finance-Wallet-Balances": "ウォレット残高",
  "Finance-Wallet-Import": "ウォレット取込",
  "Finance": "財務",
  "Genealogy": "系譜",
  "Import-Tree": "ツリー取込",
  "Logs": "ログとレポート",
  "Logs-Activity-Log": "アクティビティログ",
  "Logs-Export-History": "エクスポート履歴",
  "Logs-Reports": "レポート",
  "Manage-Accounts": "アカウント管理",
  "Manage-Accounts-Roles": "ロール",
  "Manage-Accounts-Accounts": "アカウント",
  "Marketing-Activity": "マーケティング活動",
  "Network": "ネットワーク",
  "Payment-system": "決済システム",
  "Profile": "プロフィール",
  "Reports": "レポート",
  "Settings-Currencies": "通貨",
  "Settings-Events": "イベント",
  "Settings-Event-Settings": "イベント設定",
  "Settings-Wallets": "ウォレット",
  "Settings-Payout-Methods": "支払い方法",
  "Settings-Localization": "ローカライズ",
  "Settings-Preferences": "基本設定",
  "Settings-Profile-Fields": "プロフィール項目",
  "Settings-Plan": "プラン設定",
  "Settings": "設定",
  "Visual-Binary": "ビジュアルバイナリー",
  "Visual-Genealogy": "ビジュアル系譜",
  "Visual-Tree": "ビジュアルツリー",
  "Wallet": "ウォレット",
  "Settings-Wallet-Transfer-Rules": "ウォレット送金ルールの設定",
  "periodTypes": {
    "monthly": "毎月",
    "weekly": "毎週",
    "daily": "毎日",
    "hourly": "毎時",
    "quarterHourly": "15分ごと",
    "yearly": "毎年"
  }
}
